import React from 'react';
import { useAppSelector } from "../../../../store/hooks";
import { selectCategoryEntities, selectCategoryIds } from "../../../../store/roblox/categoriesSlice";

import Tabs from "../../../../componets/Tabs";
import { TabsProps } from "antd/lib/tabs";

import './menu_extras.scss';

const _MenuCategories = () => {
  const categories  = useAppSelector(selectCategoryEntities);
  const status      = useAppSelector(state => state.roblox.categories.status);
  const ids         = useAppSelector(selectCategoryIds);
  const renderItems: TabsProps['items'] = [
    {
      label: (
        <span className='v-menu-extras--label' style={{ backgroundColor: '#6610f2' }}>
          All
        </span>
      ),
      key: ''
    }
  ];

  categories && ids.forEach((id: any) => {
    const category = categories[id];

    if (category) {
      renderItems.push({
        label: (
          <span className='v-menu-extras--label' style={{ backgroundColor: '#6610f2' }}>
            {category.name}
          </span>
        ),
        key: String(id)
      });
    }
  });

  if (status !== 'succeeded') {
    return null;
  }

  return (
     <Tabs
      animated={false}
      className='v-menu-extras'
      popupClassName='v-menu-extras--popup'
      styleType='style1'
      paramsKey='category_id'
      items={renderItems}
    />
  )

}

export default _MenuCategories;
